import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Component({
  selector: 'nx-ng-booking-summary-ticket',
  templateUrl: './booking-summary-ticket.component.html',
  styleUrls: ['./booking-summary-ticket.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingSummaryTicketComponent {
  @Input()
  id = '';

  @Input()
  title = '';

  @Input()
  description = '';

  @Input()
  price = 0;

  @Input()
  banner = '';

  @Input()
  count = 0;

  @Input()
  termDateFrom = '';

  @Input()
  termDateTo = '';

  @Input()
  isTicketIconHidden = false;

  @Output()
  infoClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(@Inject(I18NEXT_SERVICE) private i18n: ITranslationService) {}

  handleInfoClicked() {
    this.infoClicked.emit();
  }

  get translatedSubtitle(): string {
    const translatedText = this.i18n.t(this.description, {
      ns: 'tickets',
      replace: {
        termDateFrom: this.termDateFrom,
        termDateTo: this.termDateTo,
      },
    });

    return translatedText === this.description ? '' : translatedText;
  }
}
